import styled from 'styled-components';
import { getColorInitial } from '../../utils';
import { colorCSS, cssColorsFromBackgroundField, h5, minWidth, radius, shadow } from '../../styles';
export const Callout = styled.div `
  ${cssColorsFromBackgroundField({ color: 'N0' })}
  align-items: center;
  border-radius: ${radius.small};
  box-shadow: ${shadow.normal};
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1.5rem;
  text-align: left;

  @media ${minWidth.lg} {
    flex-direction: row;
    padding: 2rem;
    ${({ mediaOnRight }) => mediaOnRight && 'flex-direction: row-reverse;'}
  }
`;
export const CalloutMedia = styled.div `
  @media ${minWidth.lg} {
    width: 55%;
  }
`;
export const CalloutHeading = styled.div `
  align-items: center;
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;

  svg {
    display: block;
    height: auto;
    width: 2rem;
  }

  h3 {
    ${h5}
    margin: 0;
  }
`;
export const CalloutIcon = styled.div `
  display: none;

  @media ${minWidth.lg} {
    ${({ theme }) => theme && `color: ${colorCSS(`${getColorInitial(theme)}200`)};`}
    display: block;
  }
`;
export const CalloutText = styled.div `
  p:last-child {
    margin-bottom: 0;
  }
  @media ${minWidth.lg} {
    padding: 0 2rem;
    width: 45%;
  }
`;
//# sourceMappingURL=UiCallout.styles.js.map